// src/i18n/es.js
//
// Spanish dictionary: English text (exactly as written in the code) -> Spanish.
// Split by area so each file stays readable. Later files win on duplicates.
// To fix a translation, edit the line in the matching dict/ file.

import common from "./dict/common";
import home from "./dict/home";
import clock from "./dict/clock";
import calendar from "./dict/calendar";
import field from "./dict/field";
import pay from "./dict/pay";
import inventory from "./dict/inventory";

const ES = {
  ...common,
  ...home,
  ...clock,
  ...calendar,
  ...field,
  ...pay,
  ...inventory,
};

export default ES;
